import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ConstantData } from 'src/app/services/constants';
import { UtilService } from 'src/app/services/util.service';
import { RouteConstants } from 'src/assets/constants/route';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  playStoreLink = ConstantData.playStoreLink;

  iframeSrc: SafeResourceUrl;
  visible: boolean = false;

  openPlaystore(){
    window.open(this.playStoreLink);
  }

  @Input() showFooterMain : boolean = false;

  @Input() showFooterSecondary : boolean = false;


  routers = RouteConstants.routes;
  

  constructor(private util: UtilService, private sanitizer: DomSanitizer) {
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.util.isProduction?ConstantData.pp_prod: ConstantData.pp);
  }

  openPP(){
    this.visible = true;
  }

  route(target:string){
    this.util.route(target);
  }


}
